module.exports = __webpack_public_path__ + "media/images/service/c_7-5038df14f5f427997c5015ddd934a6b3.png";